import styled from 'styled-components/macro';
import { Divider } from '.';

export const PaymentSectionDivider = styled(Divider)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.divider.check};
  margin-top: 32px;
`;
